import { Injectable } from '@angular/core';

@Injectable()
export class ErrorHandlerService
{

    constructor()
    {
    }

    static handleError(caller: object, error: any, callerPrefix?: string, showDetail: boolean = true,
                       bubbleError: boolean = true)
    {
        const msgHeader = `[${caller.constructor.name}${callerPrefix ? `::${callerPrefix}` : ''}]`;

        if (showDetail)
        {
            console.error(`${msgHeader}`, error);
        }
        else
        {
            console.log(`${msgHeader} ` + (error.message ? error.message : error));
        }

        if (bubbleError)
        {
            throw error;
        }

        return null;
    }

}
